import { render } from "./RiskAdjustments.vue?vue&type=template&id=19a858bb&scoped=true"
import script from "./RiskAdjustments.vue?vue&type=script&lang=js"
export * from "./RiskAdjustments.vue?vue&type=script&lang=js"

import "./RiskAdjustments.vue?vue&type=style&index=0&id=19a858bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a858bb"]])

export default __exports__